import React, { useState } from 'react';
import { useInvestmentScenarios } from '../hooks/useLocalStorage';

function ScenariosManager({ currentData, onLoadScenario }) {
  const {
    scenarios,
    activeScenarioId,
    setActiveScenarioId,
    saveScenario,
    deleteScenario,
    getActiveScenario
  } = useInvestmentScenarios();

  const [showSaveDialog, setShowSaveDialog] = useState(false);
  const [scenarioName, setScenarioName] = useState('');
  const [showScenarios, setShowScenarios] = useState(false);

  const handleSaveScenario = () => {
    if (scenarioName.trim()) {
      const id = saveScenario(currentData, scenarioName.trim());
      setActiveScenarioId(id);
      setScenarioName('');
      setShowSaveDialog(false);
    }
  };

  const handleLoadScenario = (scenario) => {
    setActiveScenarioId(scenario.id);
    onLoadScenario(scenario.data);
    setShowScenarios(false);
  };

  const handleDeleteScenario = (id, e) => {
    e.stopPropagation();
    if (window.confirm('Are you sure you want to delete this scenario?')) {
      deleteScenario(id);
    }
  };

  const activeScenario = getActiveScenario();

  return (
    <div className="scenarios-manager">
      <div className="scenarios-controls">
        <button 
          onClick={() => setShowSaveDialog(true)}
          className="save-scenario-btn"
          title="Save current scenario"
        >
          💾 Save Scenario
        </button>
        
        <button 
          onClick={() => setShowScenarios(!showScenarios)}
          className="load-scenario-btn"
          title="Load saved scenario"
        >
          📂 Load Scenario
        </button>

        {activeScenario && (
          <div className="active-scenario">
            <span className="active-label">Active:</span>
            <span className="active-name">{activeScenario.name}</span>
            <button 
              onClick={() => setActiveScenarioId(null)}
              className="clear-active-btn"
              title="Clear active scenario"
            >
              ✕
            </button>
          </div>
        )}
      </div>

      {showSaveDialog && (
        <div className="save-dialog-overlay">
          <div className="save-dialog">
            <h3>Save Current Scenario</h3>
            <input
              type="text"
              value={scenarioName}
              onChange={(e) => setScenarioName(e.target.value)}
              placeholder="Enter scenario name..."
              className="scenario-name-input"
              autoFocus
            />
            <div className="dialog-buttons">
              <button onClick={handleSaveScenario} className="confirm-btn">
                Save
              </button>
              <button onClick={() => setShowSaveDialog(false)} className="cancel-btn">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showScenarios && (
        <div className="scenarios-list">
          <h3>Saved Scenarios ({scenarios.length})</h3>
          {scenarios.length === 0 ? (
            <p className="no-scenarios">No saved scenarios yet.</p>
          ) : (
            <div className="scenarios-grid">
              {scenarios.map(scenario => (
                <div 
                  key={scenario.id}
                  className={`scenario-card ${activeScenarioId === scenario.id ? 'active' : ''}`}
                  onClick={() => handleLoadScenario(scenario)}
                >
                  <div className="scenario-header">
                    <h4>{scenario.name}</h4>
                    <button 
                      onClick={(e) => handleDeleteScenario(scenario.id, e)}
                      className="delete-scenario-btn"
                      title="Delete scenario"
                    >
                      🗑️
                    </button>
                  </div>
                  <div className="scenario-details">
                    <p><strong>Initial:</strong> ${scenario.data.initialInvestment?.toLocaleString() || 'N/A'}</p>
                    <p><strong>Target:</strong> ${scenario.data.targetNetValue?.toLocaleString() || 'N/A'}</p>
                    <p><strong>Period:</strong> {scenario.data.startDate ? new Date(scenario.data.startDate).toLocaleDateString() : 'N/A'} - {scenario.data.endDate ? new Date(scenario.data.endDate).toLocaleDateString() : 'N/A'}</p>
                  </div>
                  <div className="scenario-meta">
                    <small>Created: {new Date(scenario.createdAt).toLocaleDateString()}</small>
                  </div>
                </div>
              ))}
            </div>
          )}
          <button 
            onClick={() => setShowScenarios(false)}
            className="close-scenarios-btn"
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
}

export default ScenariosManager;
